import { useCallback } from 'react'
import { useIntl } from 'react-intl'

type Values = Record<string, string | number | boolean | null | undefined>

/**
 * react-intl adapter that mirrors next-intl's `useTranslations(namespace)` API,
 * so the ported onboarding components can keep calling `t('some_key')`.
 * Keys are resolved as `${namespace}.${key}` against the flat message catalog.
 */
export function useNamespacedIntl(namespace: string) {
  const intl = useIntl()

  return useCallback(
    (key: string, values?: Values) =>
      intl.formatMessage({ id: `${namespace}.${key}` }, values),
    [intl, namespace]
  )
}
